import {Link, LinkProps} from 'react-router-dom';
import clsx from 'clsx';
import React, {ReactNode, useMemo} from 'react';
import {getBootstrapData} from '@common/core/bootstrap-data/use-backend-bootstrap-data';
import {NewsArticle} from '@app/titles/models/news-article';
import { useThemeSelector } from '@common/ui/themes/theme-selector-context';

interface Props extends Omit<LinkProps, 'to'> {
  article: NewsArticle;
  className?: string;
  textClassName?: string;
  children?: ReactNode;
  color?: 'primary' | 'inherit';
}
export function NewsArticleLink({
  article,
  className,
  textClassName,
  children,
  color = 'inherit',
  ...linkProps
}: Props) {
  const finalUri = useMemo(() => {
    return getNewsArticleLink(article.slug);
  }, [article]);

  const {selectedTheme} = useThemeSelector()


  return (
    <Link
      {...linkProps}
      className={clsx(
        color === 'primary'
          ? 'text-primary hover:text-primary-dark'
          : 'text-inherit',
        'overflow-x-hidden overflow-ellipsis outline-none transition-colors hover:underline focus-visible:underline',
        selectedTheme.is_dark ? "!text-white" : "!text-black",
        className,
      )}
      to={finalUri}
    >
      {children ? (
        children
      ) : (
        <h3 className={clsx('line-count-1 blog-heading mb-3', textClassName, selectedTheme.is_dark ? "text-white" : "text-black")}>
          {article.title}
        </h3>
      )}
    </Link>
  );
}

export function getNewsArticleLink(
  slug: string,
  {absolute}: {absolute?: boolean} = {},
): string {
  let link = `/news/${slug}`;
  if (absolute) {
    link = `${getBootstrapData().settings.base_url}${link}`;
  }
  return link;
}
